// extracted by mini-css-extract-plugin
export default {"container":"SendMessage_container__wjrhq","textItem":"SendMessage_textItem__eztxR"};